/** Pure selection helpers for task list focus and multi-select. */
export const isValidTaskId = (taskId) => typeof taskId === 'string' && !!taskId;

export function selectSingleTaskId(onSelectionChange, taskId) {
  if (!isValidTaskId(taskId)) {
    console.warn('Attempted to select a task with an invalid ID:', taskId);
    return;
  }
  if (onSelectionChange) {
    onSelectionChange([taskId]);
  }
}

export function toggleTaskIdInSelection(
  onSelectionChange,
  selectedTaskIds,
  taskId,
) {
  if (!isValidTaskId(taskId)) {
    console.warn('Attempted to toggle a task with an invalid ID:', taskId);
    return;
  }
  if (onSelectionChange) {
    const newIds = selectedTaskIds.includes(taskId)
      ? selectedTaskIds.filter((id) => id !== taskId)
      : [...selectedTaskIds, taskId];
    onSelectionChange(newIds);
  }
}

export function selectRangeTaskIds(onSelectionChange, ids) {
  if (!Array.isArray(ids) || ids.length === 0) return;
  if (onSelectionChange) {
    onSelectionChange(ids);
  }
}
